import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
/**
 * Get the list view type for the Group
 */
export default function getListViewTypeForGroup() {
    // If value not set, return Conversation type.
    var globalListViewTypeReact = getUserConfiguration().UserOptions.GlobalListViewTypeReact;
    if (globalListViewTypeReact == undefined) {
        return 0 /* Conversation */;
    }
    // Otherwise returns the GlobalListViewTypeReact in user options
    return globalListViewTypeReact;
}
//# sourceMappingURL=getListViewTypeForGroup.js.map